// Con el despacho automático de Turbo apagado, ofrecerle igual un Turbo a los
// choferes («Ofrecer a los choferes», que lo fuerza, o «Reofertar») es una
// decisión del coordinador: el servidor lo permite, así que se pregunta antes.
// Si la configuración no se puede leer, no se frena: el pedido dirá lo suyo.
export async function confirmarConTurboApagado(req: (path: string) => Promise<any>, accion: string): Promise<boolean> {
  let activo = true;
  try { activo = (await req("/v2/turbo/config"))?.config?.active !== false; } catch { /* sin configuración: sigue */ }
  return activo || window.confirm(`El despacho automático de Turbo está apagado. ¿${accion} igual?`);
}
